import { render, staticRenderFns } from "./EtkinlikForm.vue?vue&type=template&id=51e5d001"
import script from "./EtkinlikForm.vue?vue&type=script&lang=ts"
export * from "./EtkinlikForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports